import React, { FC, useRef } from 'react';
import PictureInPictureBoothLiveStream from 'components/pictureInPicture/PictureInPictureBoothLiveStream';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { LiveStreamBoothChannel, liveStreamSelectors, LiveStreamType } from 'models/liveStream';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Draggable from 'react-draggable';

const StyledPictureInPictureContainer = styled.div`
  position: fixed;
  width: 240px;
  height: 218px;
`;

const StyledDraggableBound = styled.div`
  pointer-events: none;
  position: fixed;
  width: 100%;
  height: calc(100% - 64px);
  z-index: 2;
  transform: translate(0, 64px);
`;

const StyledPictureInPictureBoothLiveStream = styled(PictureInPictureBoothLiveStream)`
  max-height: 218px;
  pointer-events: all;
`;

const PictureInPicture: FC = () => {
  const liveStreamingChannel = useSelector(liveStreamSelectors.selectCurrentChannel);
  const isDesktop = useMediaQuery('(min-width: 960px)');
  const draggableBoundRef = useRef();

  if (liveStreamingChannel == null) return null;
  switch (liveStreamingChannel.type) {
    case LiveStreamType.Booth:
      return isDesktop && (
        <StyledDraggableBound ref={draggableBoundRef}>
          <Draggable
            handle=".handle"
            defaultPosition={{ x: 20, y: 20 }}
            position={null}
            scale={1}
            bounds="parent"
            offsetParent={draggableBoundRef.current}
          >
            <StyledPictureInPictureContainer>
              <StyledPictureInPictureBoothLiveStream
                boothId={(liveStreamingChannel as LiveStreamBoothChannel).data.boothId as string}
                boothName={(liveStreamingChannel as LiveStreamBoothChannel).data.boothName}
                enableHandle
              />
            </StyledPictureInPictureContainer>
          </Draggable>
        </StyledDraggableBound>
      );
    default:
      throw new Error(`Not implemented: ${liveStreamingChannel.type}`);
  }
};

export default React.memo(PictureInPicture);
